import { useTheme } from '@mui/material';
import { BaseInput } from './BaseInput';
import type { SxProps, Theme } from '@mui/system';
import { type FC, type RefObject, useState } from 'react';

type Props = {
  label: string;
  name: string;
  error: boolean;
  helperText: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  blur?: (value: string) => void;
  value: string | number;
  sx?: SxProps<Theme>;
  type?: string;
  valueForNumberChanging?: number;
  inputRef?: RefObject<HTMLInputElement>;
  disabled?: boolean;
  updated?: boolean;
};

export const MobileTextarea: FC<Props> = ({
  sx = {},
  disabled,
  updated,
  ...props
}) => {
  const [isBigSize, setIsBigSize] = useState<boolean>(false);

  const onBlur = () => {
    setIsBigSize(false);
  };

  const onFocus = () => {
    setIsBigSize(true);
  };

  const theme = useTheme();
  const { direction } = useTheme();

  const isRtl = direction === 'rtl';

  const sxStyles: SxProps<Theme> = {
    borderRadius: '0.5rem',
    width: '100%',
    '& .MuiOutlinedInput-root': {
      '& > fieldset.MuiOutlinedInput-notchedOutline': {
        borderColor: updated
          ? theme.palette.success.main
          : theme.palette.divider,
      },
    },
    ...sx,
  };

  return (
    <BaseInput
      sx={sxStyles as SxProps}
      isTextDirectionRtl={isRtl}
      sxLabel={{
        color: '#212529',
      }}
      blur={onBlur}
      focus={onFocus}
      medium={!isBigSize}
      large={isBigSize}
      disabled={disabled}
      {...props}
    />
  );
};
